import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchRoles = async (): Promise<RoleResponse[]> => {
	const response = await cmsClient.get<RoleResponse[]>("/roles/");
	return response.data;
};

const useRoles = () => {
	return useQuery(["roles"], fetchRoles, {
		keepPreviousData: true
	});
};

export default useRoles;
